export const questionTypes = [
  { label: 'Selección', value: 'selection' },
  { label: 'Abiertas', value: 'open' },
  { label: 'Estructurada', value: 'structured' },
  { label: 'Escala de Evaluación', value: 'evaluation_scale' }
];

export const responseFormatsByType = {
  selection: [
    { label: 'Imágenes', value: 'images' },
    { label: 'Múltiple', value: 'multiple' },
    { label: 'Simple', value: 'simple' }
  ],
  open: [
    { label: 'E-mail', value: 'email' },
    { label: 'Fecha', value: 'date' },
    { label: 'Numérica', value: 'numeric' },
    { label: 'Texto', value: 'text' }
  ],
  structured: [
    { label: 'Matriz', value: 'matrix' },
    { label: 'Orden de Preferencia', value: 'preference_order' }
  ],
  evaluation_scale: [
    { label: 'Con Emojis', value: 'emojis' },
    { label: 'Con Estrellas', value: 'stars' },
    { label: 'Diferencial Semántico', value: 'semantic_differential' },
    { label: 'Escala de Likert', value: 'likert_scale' },
    { label: 'Por Puntos', value: 'points' }
  ]
};

export default [
  { label: 'Binaria', value: 'binary' },
  { label: 'Escala de Likert', value: 'likert' },
  { label: 'Selección múltiple', value: 'choices' }
];
